// AUTO-GENERATED from products.json — update whenever products change in admin
// Strategy: every page gets data at frame 0, API silently refreshes in bg

export const ALL_PRODUCTS = [
  {
    "id": "textured-gold-cuff-bracelet",
    "name": "Textured Gold Cuff Bracelet",
    "description": "A bold textured cuff designed to add effortless edge to your everyday look. Lightweight yet statement-worthy.",
    "price": 399,
    "mrp": 699,
    "collection": "gold-edit",
    "category": "Bracelet",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244901/3_rslxwi",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244882/1_i65ari",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244890/2_api2f9"
    ],
    "is_featured": false,
    "features": [
      "Adjustable fit",
      "Anti-Tarnish",
      "Statement design",
      "Lightweight",
      "Anti-Allergic"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "clover-charm-gold-bracelet",
    "name": "Clover Charm Gold Bracelet",
    "description": "A delicate clover charm bracelet symbolising luck and elegance. Perfect for stacking or wearing solo.",
    "price": 349,
    "mrp": 499,
    "collection": "after-hours",
    "category": "Bracelet",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244825/6_hcqp4g",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244818/1_wz5nkc",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244821/2_beiiqp",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244827/4_gfy3sc"
    ],
    "is_featured": false,
    "features": [
      "Minimal design",
      "Anti-tarnish",
      "Skin-friendly",
      "Lightweight"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "floral-charm-gold-bracelet",
    "name": "Floral Charm Gold Bracelet",
    "description": "Soft floral detailing meets everyday elegance. A feminine piece designed to elevate your daily style.",
    "price": 349,
    "mrp": 499,
    "collection": "after-hours",
    "category": "Bracelet",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244844/4_tslqnh",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244847/1_brgyex",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244843/2_ovztvj",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244853/5_ye4v0j"
    ],
    "is_featured": true,
    "features": [
      "Floral design",
      "Elegant look",
      "Lightweight",
      "Anti-Allergic",
      "Anti-Tarnish"
    ],
    "is_visible": true,
    "is_out_of_stock": true,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "signature-link-gold-cuff-bracelet",
    "name": "Signature Link Gold Cuff Bracelet",
    "description": "A modern link cuff crafted for bold minimal styling. Clean lines with a premium finish.",
    "price": 499,
    "mrp": 799,
    "collection": "after-hours",
    "category": "Bracelet",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244870/3_uykxrz",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244861/1_d9ysdr",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244871/2_jusatr",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244879/5_khmzuu"
    ],
    "is_featured": false,
    "features": [
      "Modern design",
      "Adjustable",
      "Premium finish",
      "Statement piece"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "classic-herringbone-gold-bracelet",
    "name": "Classic Herringbone Gold Bracelet",
    "description": "Timeless herringbone design that sits flat and shines beautifully. A must-have everyday essential.",
    "price": 349,
    "mrp": 499,
    "collection": "gold-edit",
    "category": "Bracelet",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244749/6_x7vqvp",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244745/1_gzsest",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244746/2_shcdq9",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244747/5_m4iawk"
    ],
    "is_featured": true,
    "features": [
      "Classic style",
      "Smooth finish",
      "Lightweight",
      "Versatile"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "crystal-bow-gold-ring",
    "name": "Crystal Bow Gold Ring",
    "description": "A sparkling bow ring that blends elegance with playful charm. Perfect for special moments.",
    "price": 399,
    "mrp": 699,
    "collection": "after-hours",
    "category": "Ring",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248799/1_x0xvhx",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248797/2_rmlc85",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248808/5_kzdwco",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248802/3_laz2df"
    ],
    "is_featured": true,
    "features": [
      "Crystal detailing",
      "Anti-Tarnish",
      "Statement piece",
      "Adjustable",
      "Party wear"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "crystal-bow-silver-ring",
    "name": "Crystal Bow Silver Ring",
    "description": "A delicate silver-toned bow ring adorned with crystals for a subtle yet striking look.",
    "price": 349,
    "mrp": 699,
    "collection": "after-hours",
    "category": "Ring",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248822/1_y8zf0p",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248812/2_vtirrc",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248829/6_leqwqf",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248820/3_xxac1z"
    ],
    "is_featured": false,
    "features": [
      "Crystal finish",
      "Elegant design",
      "Adjustable",
      "Lightweight"
    ],
    "is_visible": true,
    "is_out_of_stock": true,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "pearl-bloom-gold-ring",
    "name": "Pearl Bloom Gold Ring",
    "description": "A blooming pearl ring inspired by soft florals. Adds a refined feminine touch.",
    "price": 299,
    "mrp": 499,
    "collection": "pearl-edit",
    "category": "Ring",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248912/1_rdgswb",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248908/2_barmlt",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248914/3_icxsvm",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248917/4_qijiex"
    ],
    "is_featured": false,
    "features": [
      "Pearl detail",
      "Floral design",
      "Elegant",
      "Lightweight"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "lavender-bloom-pearl-ring",
    "name": "Lavender Bloom Pearl Ring",
    "description": "Lavender enamel with pearl bloom detailing creates a dreamy, romantic aesthetic.",
    "price": 299,
    "mrp": 499,
    "collection": "pearl-edit",
    "category": "Ring",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248840/2_l6dt1n",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248837/3_trnrjk",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248843/6_edfywa",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248845/8_vlgvdj"
    ],
    "is_featured": true,
    "features": [
      "Pastel enamel",
      "Anti-Tarnish",
      "Pearl accent",
      "Soft look",
      "Unique design"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "aqua-bloom-pearl-ring",
    "name": "Aqua Bloom Pearl Ring",
    "description": "Fresh aqua tones paired with pearl detailing for a refreshing everyday statement.",
    "price": 299,
    "mrp": 499,
    "collection": "pearl-edit",
    "category": "Ring",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248777/1_c30o5g",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248781/3_bjp7rc",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248783/4_fy1hdv"
    ],
    "is_featured": true,
    "features": [
      "Color enamel",
      "Pearl detail",
      "Lightweight",
      "Daily wear"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "love-hands-gold-adjustable-ring",
    "name": "Love Hands Gold Adjustable Ring",
    "description": "A playful ring forming a heart with hands. A meaningful piece full of character.",
    "price": 249,
    "mrp": 399,
    "collection": "gold-edit",
    "category": "Ring",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248891/3_looxe7",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248883/2_oi8gvo",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248887/4_mdvmda"
    ],
    "is_featured": false,
    "features": [
      "Anti-Tarnish",
      "Adjustable",
      "Unique design",
      "Lightweight",
      "Statement"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "olive-leaf-gold-adjustable-ring",
    "name": "Olive Leaf Gold Adjustable Ring",
    "description": "Inspired by nature, this olive leaf ring wraps your finger with organic elegance.",
    "price": 299,
    "mrp": 499,
    "collection": "gold-edit",
    "category": "Ring",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248902/1_vsxzbh",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248905/4_etyxzu"
    ],
    "is_featured": false,
    "features": [
      "Anti-Tarnish",
      "Nature-inspired",
      "Adjustable",
      "Minimal",
      "Elegant"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "vintage-pearl-gold-ring",
    "name": "Vintage Pearl Gold Ring",
    "description": "Vintage-inspired pearl ring with intricate detailing for a timeless charm.",
    "price": 299,
    "mrp": 499,
    "collection": "pearl-edit",
    "category": "Ring",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248929/2_ok7fdu",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248927/1_ccrpx0",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248932/3_u3ohjn"
    ],
    "is_featured": false,
    "features": [
      "Anti-Tarnish",
      "Vintage design",
      "Pearl detail",
      "Classic",
      "Elegant"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "linked-gold-statement-ring",
    "name": "Linked Gold Statement Ring",
    "description": "Bold interlinked design that stands out effortlessly. Perfect for statement styling.",
    "price": 399,
    "mrp": 699,
    "collection": "gold-edit",
    "category": "Ring",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248864/2_m9r5io",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248854/1_qnaxpe",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248864/3_nsmlx8",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776248866/4_yg594s"
    ],
    "is_featured": false,
    "features": [
      "Anti-Tarnish",
      "Statement design",
      "Bold look",
      "Premium finish",
      "Modern"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "twisted-gold-hoop-earrings",
    "name": "Twisted Gold Hoop Earrings",
    "description": "Classic hoops with a twisted texture that adds subtle dimension and shine.",
    "price": 249,
    "mrp": 399,
    "collection": "gold-edit",
    "category": "Earrings",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245408/4_wrgl0q",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245411/1_sr0mry",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245415/2_tt6aaq",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245406/3_xbvrsn"
    ],
    "is_featured": true,
    "features": [
      "Anti-Tarnish",
      "Twisted texture",
      "Lightweight",
      "Daily wear",
      "Classic"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "classic-gold-mini-hoop-earrings",
    "name": "Classic Gold Mini Hoop Earrings",
    "description": "Minimal mini hoops designed for everyday comfort and effortless style.",
    "price": 249,
    "mrp": 399,
    "collection": "gold-edit",
    "category": "Earrings",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245334/1_u247jd",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245337/2_fofyna"
    ],
    "is_featured": false,
    "features": [
      "Anti-Tarnish",
      "Minimal",
      "Lightweight",
      "Versatile",
      "Daily wear"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "bloom-pearl-stud-earrings",
    "name": "Bloom Pearl Stud Earrings",
    "description": "Soft pearl bloom studs designed to elevate your everyday elegance.",
    "price": 299,
    "mrp": 499,
    "collection": "pearl-edit",
    "category": "Earrings",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245247/2_tg4zg8",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245251/5_t0jhqa",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245249/3_un1toq",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245254/4_xuk4fi"
    ],
    "is_featured": false,
    "features": [
      "Pearl detail",
      "Elegant",
      "Lightweight",
      "Timeless"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "blush-garden-pearl-stud-earrings",
    "name": "Blush Garden Pearl Stud Earrings",
    "description": "A delicate garden-inspired design with pearl accents for a soft feminine touch.",
    "price": 299,
    "mrp": 499,
    "collection": "pearl-edit",
    "category": "Earrings",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245277/6_u6xtfw",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245268/2_sctmup",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245266/1_nkeuxu"
    ],
    "is_featured": false,
    "features": [
      "Floral design",
      "Pearl detail",
      "Lightweight",
      "Soft look"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "evil-eye-gold-hoop-earrings",
    "name": "Evil Eye Gold Hoop Earrings",
    "description": "Protective evil eye charm combined with sleek hoops for modern styling.",
    "price": 249,
    "mrp": 399,
    "collection": "after-hours",
    "category": "Earrings",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245325/5_k8fvoo",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245321/3_ulzjlq",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245319/2_fqdc8b",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245315/1_lkipq8"
    ],
    "is_featured": true,
    "features": [
      "Anti-Tarnish",
      "Evil eye charm",
      "Lightweight",
      "Trendy",
      "Everyday wear"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "golden-jellyfish-statement-earrings",
    "name": "Golden Jellyfish Statement Earrings",
    "description": "Unique jellyfish-inspired earrings designed to stand out and spark conversation.",
    "price": 299,
    "mrp": 499,
    "collection": "gold-edit",
    "category": "Earrings",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245369/3_vvrsgt",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245376/2_pg8ief",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245367/1_j592an",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245372/4_ta9xro"
    ],
    "is_featured": false,
    "features": [
      "Anti-Tarnish",
      "Statement piece",
      "Unique design",
      "Bold",
      "Art-inspired"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "classic-gold-ball-stud-earrings",
    "name": "Classic Gold Ball Stud Earrings",
    "description": "Timeless gold ball studs that go with absolutely everything.",
    "price": 249,
    "mrp": 399,
    "collection": "gold-edit",
    "category": "Earrings",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245309/4_zb5poy",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245301/1_r7o8pr",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245305/2_r9q6yp",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245303/6_s6lmhe"
    ],
    "is_featured": false,
    "features": [
      "Anti-Tarnish",
      "Minimal",
      "Classic",
      "Lightweight",
      "Daily wear"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "lavender-bloom-pearl-stud-earrings",
    "name": "Lavender Bloom Pearl Stud Earrings",
    "description": "Lavender-toned pearl studs for a soft and dreamy everyday look.",
    "price": 299,
    "mrp": 499,
    "collection": "pearl-edit",
    "category": "Earrings",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245380/1_rknvw4",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245384/3_fh6ypq",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245382/2_ic5yhz",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245386/4_tqtosd"
    ],
    "is_featured": false,
    "features": [
      "Pastel tone",
      "Pearl detail",
      "Elegant",
      "Unique"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "pearl-bloom-gold-stud-earrings",
    "name": "Pearl Bloom Gold Stud Earrings",
    "description": "A refined take on pearl studs with a golden bloom setting.",
    "price": 299,
    "mrp": 499,
    "collection": "pearl-edit",
    "category": "Earrings",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245353/1_s7bsvz",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245350/2_gte2ds",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245355/4_ddfekb",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245360/3_oxiqak"
    ],
    "is_featured": false,
    "features": [
      "Pearl bloom",
      "Elegant",
      "Lightweight",
      "Timeless"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "classic-bow-gold-stud-earrings",
    "name": "Classic Bow Gold Stud Earrings",
    "description": "Charming bow studs that add a playful yet elegant touch.",
    "price": 299,
    "mrp": 499,
    "collection": "gold-edit",
    "category": "Earrings",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245288/3_rze2fs",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245289/5_alniqv",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245286/2_b8luod",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245297/1_n5kz5t"
    ],
    "is_featured": false,
    "features": [
      "Anti-Tarnish",
      "Bow design",
      "Cute",
      "Lightweight",
      "Everyday wear"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "ballerina-crystal-gold-pendant-necklace",
    "name": "Ballerina Crystal Gold Pendant Necklace",
    "description": "A graceful ballerina pendant adorned with crystals for a delicate sparkle.",
    "price": 449,
    "mrp": 599,
    "collection": "after-hours",
    "category": "Necklace",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245528/1_ulgqvz",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245522/2_bel1rp",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245513/7_iwimgn",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245524/6_z6vu1s"
    ],
    "is_featured": false,
    "features": [
      "Anti-Tarnish",
      "Crystal detail",
      "Elegant",
      "Lightweight",
      "Statement"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "evil-eye-charm-gold-pendant-necklace",
    "name": "Evil Eye Charm Gold Pendant Necklace",
    "description": "A protective evil eye pendant designed with vibrant stones for everyday charm.",
    "price": 399,
    "mrp": 699,
    "collection": "after-hours",
    "category": "Necklace",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245608/1_dd4s0i",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245599/5_zrgnai",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245597/6_yekgro",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245602/2_tnxw36"
    ],
    "is_featured": false,
    "features": [
      "Anti-Tarnish",
      "Evil eye charm",
      "Color stones",
      "Trendy",
      "Lightweight"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "multicolor-drop-charm-gold-necklace",
    "name": "Multicolor Drop Charm Gold Necklace",
    "description": "A playful drop charm necklace with multicolor stones that adds life to any outfit.",
    "price": 699,
    "mrp": 999,
    "collection": "after-hours",
    "category": "Necklace",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245549/2_kh3zoy",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245546/1_lwqln1",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245562/7_oihkct",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245570/6_o6emf9",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245562/3_kdpuva"
    ],
    "is_featured": false,
    "features": [
      "Anti-Tarnish",
      "Multicolor stones",
      "Drop design",
      "Statement",
      "Trendy"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  },
  {
    "id": "clover-charm-multicolor-gold-necklace",
    "name": "Clover Charm Multicolor Gold Necklace",
    "description": "A vibrant clover charm necklace with multicolor accents for a fresh look.",
    "price": 599,
    "mrp": 899,
    "collection": "pearl-edit",
    "category": "Necklace",
    "image_url": "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245535/2_ttzrsm",
    "images": [
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245533/1_dibwgl",
      "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245542/3_ccygke"
    ],
    "is_featured": true,
    "features": [
      "Anti-Tarnish",
      "Clover charm",
      "Color stones",
      "Lightweight",
      "Elegant"
    ],
    "is_visible": true,
    "is_out_of_stock": false,
    "created_at": "2025-05-01T00:00:00Z"
  }
];

// Pre-computed views for each page — zero filtering cost at runtime
export const FEATURED_PRODUCTS = ALL_PRODUCTS.filter(p => p.is_featured && p.is_visible !== false);

export const PRODUCTS_BY_COLLECTION = ALL_PRODUCTS.reduce((acc, p) => {
  if (!acc[p.collection]) acc[p.collection] = [];
  acc[p.collection].push(p);
  return acc;
}, {});

export const PRODUCTS_BY_CATEGORY = ALL_PRODUCTS.reduce((acc, p) => {
  const cat = p.category;
  if (!acc[cat]) acc[cat] = [];
  acc[cat].push(p);
  return acc;
}, {});

export const PRODUCTS_BY_ID = ALL_PRODUCTS.reduce((acc, p) => {
  acc[p.id] = p;
  return acc;
}, {});

export const STATIC_COLLECTIONS = [
  { id: "gold-edit",   name: "The Gold Edit",   slug: "gold-edit",   type: "editorial", description: "Bold, sculptural, unforgettable.", image_url: "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776244857/6_jteify.png" },
  { id: "pearl-edit",  name: "The Pearl Edit",  slug: "pearl-edit",  type: "editorial", description: "Timeless elegance with luminous pearls.", image_url: "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245276/5_eyjk67.jpg" },
  { id: "after-hours", name: "After Hours",     slug: "after-hours", type: "editorial", description: "Statement pieces for unforgettable evenings.", image_url: "https://res.cloudinary.com/doaatitvq/image/upload/f_auto,q_auto/v1776245519/4_tjiz7i.png" },
];